import { render } from "./Form.vue?vue&type=template&id=0bc266ba"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=0bc266ba&lang=less"
script.render = render

export default script